<template>
  <div>
    
    <router-view></router-view>
  </div>
</template>

<script>
export default {

}
</script>

<style>
html{
  height: 100%;
}
body{


            
    
}
  .el-carousel__button{
    background-color:black !important;
  }
</style>